import { Heading, Text, cn } from '@nexa/ui';

export interface PricingCardProps {
  readonly name: string;
  readonly blurb: string;
  readonly price: string;
  readonly features: string;
  readonly highlighted?: boolean;
  readonly badge?: string;
}

/**
 * Card của `#pricing` (`template.html:1021`).
 *
 * KHÔNG dùng `Card` của `@nexa/ui`: nó khai cứng bo `card` (14) + pad 6 + hover đổi nền, còn thiết
 * kế ở đây là bo `card-lg` (16) + pad 30 + KHÔNG hover. Ép bằng `className` là đặt hai utility cùng
 * thuộc tính cạnh nhau, mà `cn()` chỉ nối chuỗi.
 *
 * KHÔNG dùng `Badge`: tone `brand` của nó là nền nhạt + chữ đậm, còn badge ở đây là **nền ĐẶC**
 * `brand-600` + chữ trắng. Không tone nào khớp.
 *
 * Ô giá có HAI hình dạng chứ không một (đếm toàn section, không đếm trong một card): bản thường
 * viền `ink-300` chữ `ink-alt-300`, bản nhấn viền `brand-200` + nền `ink-50` + chữ `brand-600`.
 * `reference.md` §3 chỉ tả một hình dạng và tả sai cả màu chữ — đừng dựng theo nó.
 *
 * Cả hai khác biệt đi qua NHÁNH LOẠI TRỪ, không phải "base rồi ghi đè": ghi đè là đặt hai utility
 * cùng thuộc tính cạnh nhau và thắng thua do thứ tự Tailwind.
 */
export function PricingCard({
  name,
  blurb,
  price,
  features,
  highlighted = false,
  badge,
}: PricingCardProps) {
  return (
    <div
      className={cn(
        'relative h-full rounded-card-lg bg-surface p-[30px]',
        highlighted ? 'shadow-pricing ring-1 ring-brand-600' : 'ring-1 ring-ink-100',
      )}
    >
      {badge !== undefined && (
        <span
          data-testid="pricing-badge"
          className="absolute -top-[11px] left-[30px] rounded-pill bg-brand-600 px-3 py-1 text-micro font-bold tracking-label text-white"
        >
          {badge}
        </span>
      )}
      <Heading level={3} size="title-lg">
        {name}
      </Heading>
      <Text size="body-sm" className="mt-1.5">
        {blurb}
      </Text>
      <div
        className={cn(
          'my-[22px] rounded-tile border border-dashed p-3.5 text-center text-body-sm',
          highlighted
            ? 'border-brand-200 bg-ink-50 text-brand-600'
            : 'border-ink-300 text-ink-alt-300',
        )}
      >
        {price}
      </div>
      <p className="text-body-sm leading-[1.9] text-ink-700">{features}</p>
    </div>
  );
}
